/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PublicShareMetaSchema {
  search_name?: string | null;
  shared_by_name?: string | null;
  shared_by_avatar_url?: string | null;
  org_name?: string | null;
}
